import { useState } from 'react';
import type { SkinFactor } from '../lib/types';
import { factorCommentary } from '../lib/skinAge';
import { SeverityBadge } from './SeverityBadge';

export function FactorRow({ factor }: { factor: SkinFactor }) {
  const commentary = factorCommentary(factor);
  const [open, setOpen] = useState(false);
  const interactive = commentary !== null;

  const color =
    factor.severity === 'high'
      ? 'text-danger'
      : factor.severity === 'moderate'
      ? 'text-warning'
      : 'text-success';

  return (
    <div>
      <button
        type="button"
        onClick={() => interactive && setOpen(o => !o)}
        disabled={!interactive}
        className="w-full text-left px-5 py-3.5 flex items-start gap-4"
      >
        <span className={`${color} mt-1 text-lg`}>●</span>
        <div className="flex-1 min-w-0">
          <p className="text-body text-text">{factor.name}</p>
          <p className="text-caption text-text-tertiary">{factor.insight}</p>
        </div>
        {interactive && (
          <span className="text-text-tertiary text-xs mt-1 select-none">
            {open ? '▴' : '▾'}
          </span>
        )}
        <SeverityBadge severity={factor.severity} />
      </button>
      {open && commentary && (
        <p className="text-body text-text-secondary leading-relaxed px-5 pb-4 pt-1">
          {commentary}
        </p>
      )}
    </div>
  );
}
